import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

import type { ProgressBarTheme } from './ProgressBar.types'

const StProgressBarContainer = styled.div<Partial<ProgressBarTheme>>`
  height: ${({ thickness }) => thickness ?? 4}px;
  width: 100%;
  background-color: ${({ theme, backgroundColor }) => backgroundColor ?? theme.Colors.Neutrals.Lighter};
  border-radius: 10px;

  overflow: hidden;

  @media ${breakpoints.fromS} {
    height: ${({ thickness }) => thickness ?? 8}px;
  }

  @media ${breakpoints.m} {
    // Fix overlap on desktop
    margin-top: ${({ theme }) => theme.UI.SpacingPx.Space6};
  }
`
const StProgressBar = styled.div<{ percentage: number } & Partial<ProgressBarTheme>>`
  width: ${({ percentage }) => percentage}%;
  height: 100%;
  background-color: ${({ theme, color }) => color ?? theme.Colors.Theme.Primary};
  border-radius: ${({ radius }) => radius ?? 0}px;

  transition: width 175ms ease-in-out;
`

export { StProgressBar, StProgressBarContainer }
